import Vue from 'vue'
import Router from 'vue-router'

let information = (resolve) => { //用户信息收集
    return require.ensure([], () => {
        resolve(require('@/views/information/information'))
    })
}

import home from '@/views/home'
import VUE404 from '@/views/404'

Vue.use(Router);

let routers = new Router({
    routes: [{
            path: '/', //匹配路由
            name: 'home',
            component: home, //引入组件
        },

        {
            path: '/information', //用户信息收集 匹配路由
            name: 'information',
            component: information, //引入组件
        },

        {
            path: '*', //匹配路由
            name: 'VUE404',
            component: VUE404, //引入组件  
        },
    ]
})

routers.beforeEach((to, from, next) => {
    //可以设置关闭加载样式

    next(vm => {
        if (vm.scroll) {
            console.log(vm.scroll)
            vm.scroll.refresh()
        }
    })
})
export default routers


// WEBPACK FOOTER //
// ./src/router/index.js